import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!window.location.pathname.startsWith("/admin")) {
      setUser(false);
      return;
    }
    api.get("/auth/me", { skipAuthRefresh: true }).then((response) => setUser(response.data)).catch(() => setUser(false));
  }, []);

  const value = useMemo(() => ({
    user,
    async login(email, password) {
      try {
        const response = await api.post("/auth/login", { email, password });
        setUser(response.data);
        return { ok: true };
      } catch (error) {
        return { ok: false, error: formatApiError(error, "Unable to sign in.") };
      }
    },
    async logout() {
      await api.post("/auth/logout");
      setUser(false);
    },
  }), [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
